import {Component} from "react";
import serverCalls from "./../../utils/serverCommunication";
import API_CONSTANTS from "./../../constants/constants";

// Procuct description component is responsible for showing product related data, and also provide action buttons.
class CGDRenderer extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.loadCGDRenderer();
        this.initialzieCGDRenderer();
    }

    componentWilUnmount() {
    }

    componentWillMount() {
    }

    callRender = () => {
        this.handleCGDRenderer();
        this.initialzieCGDRenderer();
    };

    loadScriptFromResponse = (Renderer, data, callback) => {
        var styleLink = document.createElement("link");
        var script = document.createElement("script");
        styleLink.href = `${data.rootUrl + API_CONSTANTS.CGD_REPOSITORY_LINKS.css}`;
        styleLink.rel = "stylesheet";
        styleLink.type = "text/css";
        document.body.appendChild(styleLink);
        script.src = `${data.rootUrl + API_CONSTANTS.CGD_REPOSITORY_LINKS.js}`;
        script.onload = function () {
            // Script has loaded
            Renderer.isLoaded = true;
            if (callback) {
                callback();
            }
        };
        document.body.appendChild(script);
    };

    loadCGDRenderer = () => {
        var that = this;
        var Renderer = {
            isLoaded: false
        };

        // Load the main JS bundle, if needed.
        Renderer.loadScript = callback => {
            if (Renderer.isLoaded) {
                if (callback) {
                    callback();
                }
                return;
            }

            serverCalls.getGCDRepositories().then(data => {
                this.loadScriptFromResponse(Renderer, data, callback);
            });

            //TODO:Remove var contentRoot = (window.FrontendVersionUtil && window.FrontendVersionUtil.contentRoots && window.FrontendVersionUtil.contentRoots.prevstatic) || '/prevstatic/';
        };

        // render()
        //
        // Render the CGD preview component into the target element with the given props.
        Renderer.render = function (targetEl, props, callback) {
            this.loadScript(function () {
                // If AMD is active on the page, then we need to load the module with that.
                console.log("handleCGDRenderer", that.handleCGDRenderer());
                if (typeof define === "function" && define.amd) {
                    // require(['cgd-product-renderer'], function() {
                    console.log("props", props);
                    Renderer._renderWithScript(targetEl, props, callback);
                    // });
                } else {
                    Renderer._renderWithScript(targetEl, props, callback);
                }
            });
        };

        // _renderWithScript()
        //
        // Called after the script is loaded.
        Renderer._renderWithScript = function (targetEl, props, callback) {
            // The Renderer.mountApp() function is initialized when the main JS bundle
            // is loaded. See src/page/mount-app.js
            CGDPreviewRenderer.mountApp(targetEl, props);

            if (callback) {
                callback();
            }
        };

        window.CGDPreviewRenderer = Renderer;
        return Renderer;
    };

    handleCGDRenderer = bodyViewMap => {
        var CGDPreview, PreviewError;
        var CGDRenderer = window.CGDPreviewRenderer || this.loadCGDRenderer();

        if (!CGDRenderer) {
            return PreviewError;
        }

        return CGDPreview;
    };

    initialzieCGDRenderer() {
        const {projectGuid} = this.props;
        try {
            const element = document.getElementById("cgd-preview-container");
            window.CGDPreviewRenderer.render(element, {
                uid: "000060791390", // TODO: replace static_id
                projectGUID: projectGuid,
                shareId: this.props.shareId,
                sendUrlsData: function (data) {
                    // that.setLinks(data);
                }
            });
        } catch (err) {
            console.log("Error in CGD renderer:", err);
            console.log("Preview body will be replaced with error view."); //TODO
        }
    }

    render() {
        const {previewTitle, previewSubtitle} = this.props;
        return (

            <div
                id="preview-modal"
                className="hide preview preview-photobook in cgd-preiew-modal"
                style={{display: "block"}}
            >
                <div className="modal-header desktop-only">
                    <div>
                        {" "}
                        {/** TODO: check removing it */}
                        <div className="preview-title">
                            <div className="preview-description hide-tile">
                                <div>{previewTitle}</div>
                                <div className="preview-subtitle hide-tile">
                                    {
                                        previewSubtitle &&
                                        ('"' + previewSubtitle + '"')
                                    }
                                </div>
                            </div>
                            <div className="preview-imageIndex"/>
                        </div>
                    </div>
                </div>
                <div className="modal-body" style={{height: '90%'}}>
                    <div className="description">
                        <div id="cgd-preview-container"/>
                        <div id="preview-makeNew"/>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="modal-footer-actions">
                        <ul className="list-inline list-inline-piped list-inline-right modal-action">
                            {/* <li>
                                <a className="tertiary-link" data-action="edit" onClick={this.props.editGCD}>
                                    Edit
                          </a>
                            </li>*/}
                        </ul>
                        <button
                            className="modal-action button primary-button"
                            onClick={this.props.closeModal}
                        >
                            Done
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CGDRenderer;
